import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star, Award, Building2, Rocket, Target, Lightbulb, Network, Globe, Shield, Trophy, Crown, PartyPopper } from 'lucide-react';
import { Link } from 'react-router-dom';
import SponsorCarousel from '../components/SponsorCarousel';

const sponsorsData = {
  headline: [
    {
      id: 1,
      name: "Vodacom Business",
      logo: "https://titc.io/wp-content/uploads/2025/11/VB_Further_together_StackedUp_logo-01.png",
      description: "A Leading Business Communications & Technology enabler, your platform for Fintech Innovation"
    }
  ],
  gold: [
    {
      id: 2,
      name: "Royal Park Partners",
      logo: "https://static.wixstatic.com/media/cde47b_9e718feaaaf8453aa4edf0c5ea1af5d6~mv2.png",
      description: "Global FinTech Investment Banking Advisory"
    },
    {
      id: 3,
      name: "BDO",
      logo: "https://cdn.bdo.global/images/bdo_logo/1.0.0/bdo_logo_color.png",
      description: "Professional Services & Advisory"
    }
  ],
  category: [
    {
      id: 4,
      name: "Tether",
      logo: "https://tether.to/images/logoGreen.png",
      description: "Digital Currency & Blockchain Solutions"
    },
    {
      id: 6,
      name: "Everest Wealth",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSi2Atdt5FCghRCKO6V5AkL5p7bz0h2DQ_41Q&s",
      description: "Wealth Management & Financial Services"
    },
    {
      id: 8,
      name: "Liquid C2",
      logo: "https://liquidc2.com/wp-content/uploads/sites/3//2022/11/C2-H-AH.svg",
      description: "Digital Banking & Payment Solutions Provider"
    }
  ],
  table: [
    {
      id: 8,
      name: "Peach Payments",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTn7iBUJ0Sr-HXbTSiCBqnyIMslZ_URL_4eFA&s",
      description: "Payment Processing Solutions"
    },
    {
      id: 9,
      name: "Investec",
      logo: "https://static.wixstatic.com/media/cf215e_c32a4b4a3b5745d1be07079099d2455e~mv2.png/v1/fill/w_900,h_500,al_c/cf215e_c32a4b4a3b5745d1be07079099d2455e~mv2.png",
      description: "Banking & Wealth Management"
    },
    {
      id: 10,
      name: "Adumo",
      logo: "https://www.investec.com/content/dam/south-africa/corporates-and-institutions/adumo_934x526.jpg",
      description: "Payment Solutions Provider"
    },
        {
      id: 11,
      name: "Range Rover",
      logo: "https://titc.io/wp-content/uploads/2025/07/L46000GL_303103837_devicemark_Slate_Blue_RGB_png.png",
      description: "Powered by Range Rover"
    },
    {
      id: 12,
      name: "TransUnion",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8ob435isjIJxvaFUQPX4j6CSvjFvaWUY3Mg&s",
      description: "Credit Information & Risk Management Solutions"
    }
  ]
};


const judges = [
  {
    name: "Ashlin Perumall",
    title: "Partner, Baker McKenzie",
    image: "https://titc.io/wp-content/uploads/2025/02/ashkin.jpeg",
    description: "Ashlin Perumall is a partner in Baker McKenzie's corporate M&A and IPTech practice groups in Johannesburg.."
  },
    {
    name: "Wendy Pienaar",
    title: "Strategy Lead, Deloitte Africa",
    image: "https://titc.io/wp-content/uploads/2025/02/wendy.jpeg",
    description: "Wendy is currently the Strategy Lead for Deloitte Africa including the Innovation and Ventures portfolio. Wendy has a passion for the African Fintech space and has helped many move through the ideate, incubate industrialise, scale and mature phases."
              },
  {
    name: "Arno Von Helden",
    title: "CIO Transactional Products & Solutions, Investec",
    image: "https://titc.io/wp-content/uploads/2025/02/arono.jpeg",
    description: "Prior to joining Investec, Arono was the CEO of Shyft by Standard Bank and comes with a formidable track record of developing and managing innovative digital platform businesses."
  },
  {
    name: "Angela itzikowitz",
    title: "Professor, ENS",
    image: "https://www.ensafrica.com/Uploads/People/1055_Angela%20Itzikowitz%20AI002.jpg?width=250&height=310&scale=upscalecanvas&mode=crop&quality=90&format=jpg",
    description: "Commerical lawyer with extensive experience in fintech."
  },
  {
    name: "Lee Naik",
    title: "CEO, TransUnion Africa",
    image: "https://titc.io/wp-content/uploads/2025/02/lee.jpeg",
    description: "Lee is recognized as one of the continent's leading authorities on how technology can be used to solve problems that matter."
  },
  {
    name: "Chris Wood",
    title: "Managing Executive, ABSA Group",
    image: "https://titc.io/wp-content/uploads/2025/02/chris.jpg",
    description: "Banker, FinTech Executive and expert in Payments across Africa."
  },
  {
    name: "Cleola (Soundy) Kunene",
    title: "Head of SME Development, JSE Ltd",
    image: "https://titc.io/wp-content/uploads/2025/02/1732961494986.jpeg",
    description: "Award Winning small business growth and investment expert, from Start-Up to Scale-Up"
  },
];

const Home = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollElement = scrollRef.current;
    if (!scrollElement) return;

    const scroll = () => {
      if (scrollElement.scrollLeft >= scrollElement.scrollWidth - scrollElement.clientWidth) {
        scrollElement.scrollLeft = 0;
      } else {
        scrollElement.scrollLeft += 1;
      }
    };

    const intervalId = setInterval(scroll, 30);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="relative">
      {/* Winners Announced Banner */}
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.5 }}
        className="relative overflow-hidden"
      >
        <div className="bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 py-4">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <Link
              to="/winners"
              className="flex items-center justify-center space-x-4 text-center group hover:scale-105 transition-transform duration-300"
            >
              <PartyPopper className="h-8 w-8 text-white animate-bounce" />
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-white mb-1">
                  🎉 WINNERS ANNOUNCED! 🎉
                </h2>
                <p className="text-white/90 text-lg">
                  Congratulations to all our 2025 SA FinTech Awards Winners
                </p>
              </div>
              <ArrowRight className="h-8 w-8 text-white group-hover:translate-x-2 transition-transform duration-300" />
            </Link>
          </div>
        </div>
        
        {/* Animated sparkles */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-2 left-1/4 w-2 h-2 bg-white rounded-full animate-ping opacity-75"></div>
          <div className="absolute top-4 right-1/3 w-1 h-1 bg-white rounded-full animate-pulse opacity-60"></div>
          <div className="absolute bottom-3 left-1/3 w-1.5 h-1.5 bg-white rounded-full animate-bounce opacity-80"></div>
          <div className="absolute bottom-2 right-1/4 w-1 h-1 bg-white rounded-full animate-ping opacity-70"></div>
        </div>
      </motion.div>
      {/* Hero Section with Parallax Effect */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <motion.div
          initial={{ scale: 1.1 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.5 }}
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: 'url(https://titc.io/wp-content/uploads/2024/08/Award.webp)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70" />
        </motion.div>

        <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold text-white mb-8 leading-tight">
              South African
              <span className="block" style={{ color: '#C1B3A3' }}>
                FinTech Awards 2025
              </span>
            </h1>
            <p className="text-xl sm:text-2xl text-gray-200 mb-12 max-w-3xl mx-auto">
              Celebrating Innovation in Financial Technology
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
              <Link
                to="/categories"
                className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-4 text-white font-semibold rounded-full transition-all duration-300 transform hover:scale-105"
                style={{ backgroundColor: '#C1B3A3' }}
              >
                Nominate <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
              <Link
                to="/tickets"
                className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-4 text-white font-semibold rounded-full backdrop-blur-sm hover:bg-white/20 transition-all duration-300"
                style={{ backgroundColor: 'rgba(193, 179, 163, 0.2)' }}
              >
                Reserve a Table <Award className="ml-2 h-5 w-5" />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Event Overview Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold mb-6" style={{ color: '#1A1A1A' }}>
              Shaping the Future of African FinTech
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Join us for an unprecedented celebration of innovation, where Africa's brightest minds 
              in financial technology converge to honor excellence and shape tomorrow's digital economy
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="relative group"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl transform transition-transform group-hover:scale-105" />
              <div className="relative p-8 text-white">
                <Trophy className="h-12 w-12 mb-6" style={{ color: '#C1B3A3' }} />
                <h3 className="text-xl font-bold mb-4">12 Elite Categories</h3>
                <p className="text-gray-300">
                  Recognizing groundbreaking achievements across the entire fintech ecosystem, from 
                  digital banking to sustainable finance
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="relative group"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl transform transition-transform group-hover:scale-105" />
              <div className="relative p-8 text-white">
                <Globe className="h-12 w-12 mb-6" style={{ color: '#C1B3A3' }} />
                <h3 className="text-xl font-bold mb-4">Industry Luminaries</h3>
                <p className="text-gray-300">
                  Network with 500+ C-suite executives, innovators, and investors shaping Africa's 
                  financial future
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="relative group"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl transform transition-transform group-hover:scale-105" />
              <div className="relative p-8 text-white">
                <Shield className="h-12 w-12 mb-6" style={{ color: '#C1B3A3' }} />
                <h3 className="text-xl font-bold mb-4">Distinguished Panel</h3>
                <p className="text-gray-300">
                  Evaluated by an elite panel of industry pioneers, thought leaders, and financial 
                  technology experts
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="relative group"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl transform transition-transform group-hover:scale-105" />
              <div className="relative p-8 text-white">
                <Network className="h-12 w-12 mb-6" style={{ color: '#C1B3A3' }} />
                <h3 className="text-xl font-bold mb-4">Global Recognition</h3>
                <p className="text-gray-300">
                  Showcase your innovation to a global audience through extensive media coverage and 
                  industry partnerships
                </p>
              </div>
            </motion.div>
          </div>

          {/* Why Attend Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
            {[
              {
                icon: <Network className="h-12 w-12" />,
                title: "Network with the Best",
                description: "Connect with industry pioneers, investors, and decision-makers in an exclusive setting"
              },
              {
                icon: <Rocket className="h-12 w-12" />,
                title: "Celebrate Innovation",
                description: "Witness groundbreaking solutions and transformative technologies shaping the future of finance"
              },
              {
                icon: <Target className="h-12 w-12" />,
                title: "Drive Growth",
                description: "Create valuable partnerships and explore new opportunities for business expansion"
              }
            ].map((item, index) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2 }}
                className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border"
                style={{ borderColor: 'rgba(193, 179, 163, 0.2)' }}
              >
                <div className="mb-6" style={{ color: '#C1B3A3' }}>
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-4">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </motion.div>
            ))}
          </div>

          {/* Industry Impact */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-12 text-white"
          >
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-3xl font-bold mb-6" style={{ color: '#C1B3A3' }}>
                  Shaping the Future of Finance
                </h3>
                <p style={{ color: '#fff' }} className="mb-8 text-lg">
                  The South African FinTech Awards celebrates excellence and innovation in the financial
                  technology sector. Join us as we recognize the companies and individuals who are
                  shaping the future of finance in South Africa.
                </p>
                <div className="space-y-4">
                  {[
                    "Recognizing breakthrough technologies and solutions",
                    "Promoting collaboration between traditional and digital finance",
                    "Showcasing South Africa's fintech excellence globally",
                    "Fostering innovation and entrepreneurship"
                  ].map((item, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <Lightbulb className="h-5 w-5" style={{ color: '#C1B3A3' }} />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="grid grid-cols-2 gap-6">
                {[
                  { number: "500+", label: "Industry Leaders" },
                  { number: "12", label: "Award Categories" },
                  { number: "50+", label: "Media Partners" },
                  { number: "∞", label: "Opportunities" }
                ].map((stat, index) => (
                  <motion.div
                    key={stat.label}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1 }}
                    className="text-center p-6 rounded-xl"
                    style={{ backgroundColor: 'rgba(193, 179, 163, 0.1)' }}
                  >
                    <div className="text-3xl font-bold mb-2" style={{ color: '#C1B3A3' }}>
                      {stat.number}
                    </div>
                    <div className="text-sm text-gray-300">{stat.label}</div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Headline Sponsor Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <div className="flex items-center justify-center mb-6">
              <Crown className="h-8 w-8 mr-3" style={{ color: '#C1B3A3' }} />
              <h2 className="text-4xl font-bold" style={{ color: '#1A1A1A' }}>
                Headline Sponsor
              </h2>
            </div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12">
              We are proud to partner with industry leaders who share our vision for innovation in South African FinTech
            </p>
            
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="max-w-2xl mx-auto"
            >
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-2xl overflow-hidden border-2 border-gray-100 hover:shadow-3xl transition-all duration-500 transform hover:-translate-y-2">
                <div className="p-12">
                  <div className="h-32 flex items-center justify-center mb-8">
                    <img
                      src="https://titc.io/wp-content/uploads/2025/11/VB_Further_together_StackedUp_logo-01.png"
                      alt="Vodacom Business"
                      className="max-h-full max-w-full object-contain filter hover:brightness-110 transition-all duration-300"
                    />
                  </div>
                  <div className="text-center">
                    <h3 className="text-3xl font-bold mb-4" style={{ color: '#1A1A1A' }}>
                      Vodacom Business
                    </h3>
                    <p className="text-lg text-gray-600 mb-6">
                      A Leading Business Communications & Technology enabler, your platform for Fintech Innovation
                    </p>
                    <div className="inline-flex items-center px-6 py-3 rounded-full text-white font-semibold"
                         style={{ backgroundColor: '#C1B3A3' }}>
                      <Crown className="h-5 w-5 mr-2" />
                      <span>Headline Partner</span>
                    </div>
                  </div>
                </div>
                <div className="h-2 bg-gradient-to-r from-red-600 via-red-500 to-red-600"></div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Sponsors Section */}
      <section className="py-20 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold mb-6" style={{ color: '#1A1A1A' }}>
              Our Supporting Sponsors
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Additional partners supporting excellence in South African FinTech
            </p>
          </motion.div>

          <SponsorCarousel sponsors={[...sponsorsData.gold, ...sponsorsData.category, ...sponsorsData.table]} />
          <SponsorCarousel sponsors={[...sponsorsData.headline, ...sponsorsData.gold, ...sponsorsData.category, ...sponsorsData.table]} />

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mt-8"
          >
            <Link
              to="/sponsors"
              className="inline-flex items-center text-lg font-semibold hover:underline"
              style={{ color: '#C1B3A3' }}
            >
              View All Sponsors <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Powered by Range Rover Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-20"
          >
            <div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-2xl p-12 text-center">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="max-w-2xl mx-auto"
              >
                <h3 className="text-2xl font-bold text-white mb-8">Powered by</h3>
                <div className="bg-white rounded-xl p-8 shadow-xl">
                  <a
                    href="https://www.rangerover.com/en-za/range-rover/index.html?utm_source=Social&utm_campaign=SA_FinTech_Awards_2025"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block hover:opacity-80 transition-opacity duration-300"
                  >
                    <img
                      src="https://titc.io/wp-content/uploads/2025/07/L46000GL_303103837_devicemark_Slate_Blue_RGB_png.png"
                      alt="Range Rover"
                      className="max-h-12 mx-auto object-contain"
                    />
                  </a>
                </div>
                <p className="text-gray-300 mt-6 text-lg">
                  Proudly supported by Range Rover, driving excellence in luxury and innovation
                </p>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Judges Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold mb-4" style={{ color: '#C1B3A3' }}>
              Meet Our Distinguished Judges
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Our panel of experts brings together decades of experience in finance, technology, and innovation
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {judges.map((judge, index) => (
              <motion.div
                key={judge.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="group relative overflow-hidden rounded-lg bg-white shadow-xl hover:shadow-2xl transition-all duration-300"
              >
                <div className="aspect-w-1 aspect-h-1">
                  <img
                    src={judge.image}
                    alt={judge.name}
                    className="w-full h-48 object-cover object-center transform group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/70 to-transparent opacity-90 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-base font-bold text-white mb-1 line-clamp-1">{judge.name}</h3>
                  <p className="text-sm font-medium text-gray-300 mb-2 line-clamp-2">{judge.title}</p>
                  <p className="text-xs text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300 line-clamp-3">
                    {judge.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20" style={{ background: 'rgba(193,179,163,0.1)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="relative"
            >
              <div className="absolute -inset-4 rounded-2xl opacity-10 blur-lg"
                   style={{ backgroundColor: '#C1B3A3' }} />
              <div className="relative">
                <h2 className="text-4xl font-bold mb-6" style={{ color: '#C1B3A3' }}>
                  About the Awards
                </h2>
                <p style={{ color: '#666' }} className="mb-8 text-lg">
                  The South African FinTech Awards celebrates excellence and innovation in the financial
                  technology sector. Join us as we recognize the companies and individuals who are
                  shaping the future of finance in South Africa.
                </p>
                <Link
                  to="/about"
                  className="inline-flex items-center font-semibold group"
                  style={{ color: '#C1B3A3' }}
                >
                  Learn More{' '}
                  <ArrowRight className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="relative"
            >
              <div className="absolute inset-0 rounded-2xl transform rotate-3"
                   style={{ backgroundColor: '#C1B3A3' }} />
              <img
                src="https://titc.io/wp-content/uploads/2024/08/8FnK5SI-QDO4wpxBY1NpzA-1.webp"
                alt="FinTech Conference"
                className="relative rounded-2xl shadow-2xl transform -rotate-3 hover:rotate-0 transition-transform duration-500"
              />
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;